var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReferralReward = function SvgReferralReward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9474,
    cy: 18.9474,
    r: 18.9474,
    fill: "#191A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6521 13.6657C23.7885 13.5961 23.9198 13.5171 24.0452 13.4291C25.061 12.7159 25.3742 11.4043 24.741 10.5067C24.1078 9.60917 22.7719 9.46305 21.756 10.1832C20.7401 10.9033 20.2183 12.1767 19.6512 13.6622L23.6521 13.6657ZM11.3225 18.2927H27.5381V26.5379C27.5381 26.907 27.3915 27.2609 27.1305 27.5219C26.8695 27.7829 26.5156 27.9295 26.1465 27.9295H12.7141C12.345 27.9295 11.9911 27.7829 11.7301 27.5219C11.4691 27.2609 11.3225 26.907 11.3225 26.5379V18.2927Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.464 18.2925H17.3936V27.9293H21.464V18.2925Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.205 13.6657C15.0693 13.5969 14.939 13.5178 14.8154 13.4291C13.7995 12.7159 13.4829 11.4043 14.1196 10.5067C14.7562 9.60917 16.0887 9.46305 17.108 10.1832C18.1274 10.9034 18.6423 12.1767 19.2128 13.6622L15.205 13.6657Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2563 13.6655H11.6008C11.0244 13.6655 10.5571 14.1328 10.5571 14.7092V17.2489C10.5571 17.8253 11.0244 18.2926 11.6008 18.2926H27.2563C27.8327 18.2926 28.3 17.8253 28.3 17.2489V14.7092C28.3 14.1328 27.8327 13.6655 27.2563 13.6655Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8361 13.6655H17.0247V18.2926H21.8361V13.6655Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReferralReward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/referral-reward.26623b49.svg";
export { ForwardRef as ReactComponent };